/**
 * MD-14 FE-LANDINGS - /expat landing copy (EN-first visa wedge)
 *
 * Reference: STRATEGY Sec.4 + F-FE-LANDINGS.md Sec.1. Reddit /r/VietNam +
 * expat.com channel deeplink target.
 */

import type { LandingCatalog } from './landing-types';

export const expatVi: LandingCatalog<'vi'> = {
  meta_title: 'Asklaw cho người nước ngoài - visa, TRC, hôn nhân quốc tế',
  meta_description:
    'Trợ lý pháp lý AI cho người nước ngoài tại Việt Nam: gia hạn TRC, giấy phép lao động, hôn nhân quốc tế, thuế thu nhập cá nhân.',
  hero_eyebrow: 'Cho người nước ngoài tại Việt Nam',
  hero_headline: 'Visa, TRC, giấy phép lao động - giải thích kèm trích dẫn đối chiếu được',
  hero_subhead:
    'Hết phải đoán. Asklaw trả lời các câu hỏi về gia hạn TRC, xin giấy phép lao động, hôn nhân xuyên quốc gia và thuế thu nhập cá nhân - trích dẫn chính xác Điều/Khoản từ luật Việt Nam.',
  cta_primary: 'Hỏi bằng tiếng Anh',
  cta_secondary: 'Xem Doc Pack',
  feature_1_title: 'Giấy phép lao động và TRC',
  feature_1_body:
    'Nghị định 152/2020/NĐ-CP, Thông tư 04/2024/TT-BLĐTBXH - bao phủ đầy đủ kèm thời hạn gia hạn.',
  feature_2_title: 'Gia đình xuyên quốc gia',
  feature_2_body:
    'Đăng ký kết hôn, ly hôn, quyền nuôi con - Luật Hôn nhân và Gia đình 52/2014/QH13.',
  feature_3_title: 'Thuế cho người nước ngoài',
  feature_3_body:
    'Thuế thu nhập cá nhân cho người không cư trú, hiệp định tránh đánh thuế hai lần - Luật Thuế thu nhập cá nhân.',
  pricing_intro: 'Hỏi miễn phí. Doc Pack từ 19 USD (hoặc tương đương VND).',
  footer_disclaimer:
    'Asklaw là công cụ AI tham khảo thông tin pháp luật, KHÔNG phải dịch vụ tư vấn pháp lý. ' +
    'Mọi kết quả do AI tạo, có thể sai sót. Để được tư vấn chính thức cho vụ việc cụ thể, ' +
    'vui lòng liên hệ luật sư có chứng chỉ hành nghề.',
};

export const expatEn: LandingCatalog<'en'> = {
  meta_title: 'Asklaw for expats - Vietnam visa, TRC, cross-border marriage',
  meta_description:
    'AI Legal Copilot for expats in Vietnam: TRC renewal, work permit, international marriage, personal tax - with verifiable citations.',
  hero_eyebrow: 'For expats in Vietnam',
  hero_headline: 'Visa, TRC, work permit - explained with verifiable citations',
  hero_subhead:
    'Stop guessing. Asklaw answers TRC renewal, WP application, cross-border marriage, and personal tax - citing the exact Article/Clause from official Vietnamese law.',
  cta_primary: 'Ask in English',
  cta_secondary: 'Browse Doc Packs',
  feature_1_title: 'TRC + Work Permit',
  feature_1_body:
    'Decree 152/2020/NĐ-CP, Circular 04/2024/TT-BLĐTBXH - full coverage with renewal timelines.',
  feature_2_title: 'Cross-border family',
  feature_2_body:
    'Marriage registration, divorce, child custody - Law on Marriage and Family 52/2014/QH13.',
  feature_3_title: 'Tax for foreigners',
  feature_3_body:
    'Personal income tax for non-residents, double-tax treaties - Law on PIT.',
  pricing_intro: 'Free chat. Doc Pack from $19 (USD or VND).',
  footer_disclaimer:
    'Asklaw is an AI tool for legal information reference only, NOT a legal advisory service. ' +
    'All outputs are AI-generated and may contain errors. For formal advice on specific matters, ' +
    'please consult a licensed Vietnamese lawyer.',
};
